import React from 'react'
import PropTypes from 'prop-types'
import { Field, change } from 'redux-form'
import { InputField, SelectField, DatePickerField } from 'FormFields'
import { FORM_NAME } from '../Form'
import moment from 'moment'

const labelColSpan = 6
const wrapperColSpan = 16

export default class extends React.PureComponent {

  static propTypes = {
    subcontractors: PropTypes.array.isRequired,
    projects: PropTypes.array.isRequired,
    users: PropTypes.array.isRequired,
    subOrderStatuses: PropTypes.array.isRequired,
    subOrder: PropTypes.object,
    submitting: PropTypes.bool.isRequired,
    projectId: PropTypes.number,
    statusKey: PropTypes.number,
    setPercentage: PropTypes.number,
    setAmount: PropTypes.number,
    orderTotal: PropTypes.number,
    dispatch: PropTypes.func.isRequired,
  }

  componentDidUpdate(prevProps) {
    const { statusKey, dispatch, subOrder, subcontractors } = this.props
    
    // When status changes to Approved (3), set default values
    if (statusKey === 3 && prevProps.statusKey !== 3) {
      // Set approved_at to current date/time if not already set
      dispatch(change(FORM_NAME, 'approved_at', moment()))
      
      // Set approved_by to subcontractor's user if available
      if (subOrder && subOrder.subcontractor && subOrder.subcontractor.user_id) {
        dispatch(change(FORM_NAME, 'approved_by', subOrder.subcontractor.user_id))
      } else if (subOrder && subOrder.subcontractor_id) {
        // Fallback: find subcontractor in the list and get their user_id
        const subcontractor = subcontractors.find(s => s.id === subOrder.subcontractor_id)
        if (subcontractor && subcontractor.user_id) {
          dispatch(change(FORM_NAME, 'approved_by', subcontractor.user_id))
        }
      }
    }
  }

  getApprovedByOptions = () => {
    const { users, subOrder } = this.props
    
    // Start with the standard users list
    const options = users.map(user => ({
      label: user.full_name,
      value: user.id,
    }))
    
    // Add the subcontractor's user to the options if they have one and aren't already in the list
    if (subOrder && subOrder.subcontractor && subOrder.subcontractor.user_id) {
      const subcontractorUserId = subOrder.subcontractor.user_id
      const existsInList = users.some(function(user) { return user.id === subcontractorUserId })
      
      if (!existsInList) {
        // Use subcontractor name as the label for their user
        options.unshift({
          label: subOrder.subcontractor.name + ' (Subcontractor)',
          value: subcontractorUserId,
        })
      }
    }
    
    return options
  }

  handlePercentageChange = (e) => {
    console.log('=== handlePercentageChange called ===')
    const { dispatch, orderTotal } = this.props
    const newValue = e.target.value
    
    console.log('newValue:', newValue)
    console.log('orderTotal from props:', orderTotal)
    
    if (!newValue || newValue === '') {
      console.log('Exiting early - missing newValue')
      return
    }

    if (!orderTotal) {
      console.warn('No order total available, cannot calculate')
      return
    }

    const calculatedAmount = (orderTotal * parseFloat(newValue)) / 100
    console.log('Calculated amount:', calculatedAmount)
    dispatch(change(FORM_NAME, 'set_amount', calculatedAmount.toFixed(2)))
  }

  handleAmountChange = (e) => {
    console.log('=== handleAmountChange called ===')
    const { dispatch, orderTotal } = this.props
    const newValue = e.target.value
    
    console.log('newValue:', newValue)
    console.log('orderTotal from props:', orderTotal)
    
    if (!newValue || newValue === '') {
      console.log('Exiting early - missing newValue')
      return
    }

    if (!orderTotal) {
      console.warn('No order total available, cannot calculate')
      return
    }

    const calculatedPercentage = (parseFloat(newValue) / orderTotal) * 100
    console.log('Calculated percentage:', calculatedPercentage)
    dispatch(change(FORM_NAME, 'set_percentage', calculatedPercentage.toFixed(2)))
  }

  render() {

    const {
      subcontractors,
      projects,
      users,
      subOrderStatuses,
      statusKey,
      submitting,
    } = this.props

    return (

      <React.Fragment>

        <Field
          name='reference'
          label='Reference'
          component={InputField}
          disabled={submitting}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
        />

        <Field
          name='status_key'
          label='Status'
          component={SelectField}
          options={subOrderStatuses.map(status => ({
            label: status.title,
            value: status.key,
          }))}
          disabled={submitting}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
        />

        {statusKey === 3 && (
          <React.Fragment>
            <Field
              name='approved_by'
              label='Approved By'
              component={SelectField}
              options={this.getApprovedByOptions()}
              disabled={submitting}
              labelCol={{ span: labelColSpan }}
              wrapperCol={{ span: wrapperColSpan }}
            />

            <Field
              name='approved_at'
              label='Approved At'
              component={DatePickerField}
              disabled={submitting}
              labelCol={{ span: labelColSpan }}
              wrapperCol={{ span: wrapperColSpan }}
              showTime
              displayFormat='DD-MM-YYYY HH:mm'
              valueFormat='YYYY-MM-DD HH:mm:ss'
            />
          </React.Fragment>
        )}

        <Field
          name='subcontractor_id'
          label='Subcontractor'
          component={SelectField}
          options={subcontractors.map(subcontractor => ({
            label: subcontractor.name,
            value: subcontractor.id,
          }))}
          disabled={submitting}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
        />

        <Field
          name='project_id'
          label='Project'
          component={SelectField}
          options={projects.map(project => ({
            label: `[${project.number}] ${project.client_site.client.name} - ${project.client_site.name}`,
            value: project.id,
          }))}
          disabled={submitting}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
        />

        <Field
          name='user_id'
          label='Owner'
          component={SelectField}
          options={users.map(user => ({
            label: user.full_name,
            value: user.id,
          }))}
          disabled={submitting}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
        />

        <Field
          name='date'
          label='Date'
          component={DatePickerField}
          disabled={submitting}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
        />

        <Field
          name='vat_perc'
          label='Vat %'
          component={SelectField}
          options={[
            { label: 0, value: 0 },
            { label: 20, value: 20 },
          ]}
          disabled={submitting}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
        />

        <Field
          name='retention_percentage'
          label='Retention %'
          component={InputField}
          type='number'
          step='0.01'
          disabled={submitting}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
        />

        <Field
          name='set_percentage'
          label='Set %'
          component={InputField}
          type='number'
          step='0.01'
          onBlur={this.handlePercentageChange}
          disabled={submitting}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
        />

        <Field
          name='set_amount'
          label='Set Amount'
          component={InputField}
          type='number'
          step='0.01'
          onBlur={this.handleAmountChange}
          disabled={submitting}
          labelCol={{ span: labelColSpan }}
          wrapperCol={{ span: wrapperColSpan }}
        />

      </React.Fragment>

    )

  }

}
